import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SiteLayout from "@/pages/SiteLayout";
import HomePage from "@/pages/HomePage";
import ReviewsPage from "@/pages/ReviewsPage";
import WaiverPage from "@/pages/WaiverPage";
import ServicesPage from "@/pages/ServicesPage";
import GroomersPage from "@/pages/GroomersPage";
import GroomIQPage from "@/pages/GroomIQPage";
import VisitPage from "@/pages/VisitPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="grid min-h-screen place-items-center bg-lavender-50" data-testid="admin-loading">
        <Loader2 className="animate-spin text-lavender-600" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/waiver" element={<WaiverPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/groomers" element={<GroomersPage />} />
            <Route path="/groomiq" element={<GroomIQPage />} />
            <Route path="/visit" element={<VisitPage />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
